import { DocumentGroup, DocumentGroupAbstract, DocumentInfo } from 'types/documentGroup';
import { Workflow } from 'types/workflow';

export default (groupAbstract: DocumentGroupAbstract): DocumentGroup => {
  const documents: DocumentInfo[] = groupAbstract.documents.map((doc) => ({
    processingJobId: doc.processingJobId,
    documentId: doc.documentId,
  }));

  const groupWorkflow: Workflow = {
    id: undefined,
    name: undefined,
  };

  const documentWorkflow: Workflow = {
    id: groupAbstract.workflowId,
    name: undefined,
  };

  return {
    documentWorkflow,
    groupWorkflow,
    groupName: groupAbstract.groupName,
    id: groupAbstract.documentGroupId,
    documents,
    externalDataSource: groupAbstract.externalDataSource,
    documentIdsToExtract: groupAbstract.documentIdsToExtract,
  };
};
